angular.module('tgaApp').controller('InfoController', [
  '$scope',
  'analyticsService',
  'soundService',
  'gameConfig',
  '$log',
  function ($scope, analyticsService, soundService, gameConfig, $log) {
    $scope.data = {
      title: $scope.game.popup.title,
      body: $scope.game.popup.body,
      background: $scope.splashBackground,
    };

    $scope.initialize = function () {
      $log.debug('Info state');

      if (!$scope.game.popup || (!$scope.game.popup.title && !$scope.game.popup.body)) {
        $scope.continue();
      }
    };

    $scope.submit = function () {
      if (!gameConfig.sfx_muted) {
        soundService.play('click');
      }

      $scope.continue();
    };

    $scope.continue = function () {
      $scope.analyticsService.sendEvent({
        category: 'player action',
        action: 'button clicked',
        label: 'info ok',
      });

      $scope.registerOrNot();
    };

    $scope.initialize();
  },
]);
